<template>
  <DataList
    title="Документи"
    resource="documents"
    :headers="headers"
    :filter="filter"
    :add-route="{ name: 'gen-doc-documents' }"
  >
    <template v-slot:filters>
      <v-row no-gutters>
        <v-col md="12" sm="12">
          <SelectTags
            v-model="tags"
            :multiple-select="true"
            class="my-4 mx-1"
          />
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import DataList from "../../components/DataList.vue";
import SelectTags from "../tags/SelectTags.vue";
import * as tagsApi from "../../backend/tagsApi.js";

export default {
  components: {
    DataList,
    SelectTags,
  },
  data: () => ({
    headers: [
      { text: "Назва", name: "title", type: "route", sortable: false },
      { text: "Автор блока", name: "author", type: "object", sortable: false },
      {
        text: "Дата створення",
        name: "date",
        type: "date",
        sortable: false,
      },
      {
        text: "Автор змін",
        name: "updater",
        type: "object",
        sortable: false,
      },
      {
        text: "Останні зміни",
        name: "updateDate",
        type: "date",
        sortable: false,
      },
      {
        text: "",
        type: "action",
        sortable: false,
      },
    ],
    tags: [],
  }),
  computed: {
    filter() {
      return {
        tags: this.tags,
      };
    },
  },
  created() {
    this.getTags();
  },
  methods: {
    async getTags() {
      const query = this.$router.currentRoute.query?.tags;
      if (!query) {
        return;
      }
      if (Array.isArray(query)) {
        for (let i = 0; i < query.length; i++) {
          this.tags.push(await tagsApi.getTag(query[i]));
        }
      } else {
        this.tags.push(await tagsApi.getTag(query));
      }
    },
  },
};
</script>
